import { render, staticRenderFns } from "./NameServersEditor.vue?vue&type=template&id=27e8904e&"
import script from "./NameServersEditor.vue?vue&type=script&lang=js&"
export * from "./NameServersEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e8904e')) {
      api.createRecord('27e8904e', component.options)
    } else {
      api.reload('27e8904e', component.options)
    }
    module.hot.accept("./NameServersEditor.vue?vue&type=template&id=27e8904e&", function () {
      api.rerender('27e8904e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DnsEditor/NameServersEditor.vue"
export default component.exports